module.exports = __webpack_public_path__ + "img/uebungsdienstwasser.da99bd0b.jpg";